export default __webpack_public_path__ + "2010adb1dc5f171bf90908aa1a0d35c0.png";